import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormModule } from './views/form/form.module';
import { HttpClientModule } from '@angular/common/http';
import { QuillModule } from 'ngx-quill';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { initializeKeycloak } from './utility/app.init';
import { SearchModule } from './views/search/search.module';
import { DocumentService } from './services/document.service';
import { HeaderComponent } from './views/header/header.component';
import { FooterComponent } from './views/footer/footer.component';
import { MainDialogComponent } from './views/dialogComponents/main dialog/main-dialog.component';
import { UsecaseLocationComponent } from './views/dialogComponents/usecaseLocation.component';
import { AgmCoreModule, GoogleMapsAPIWrapper } from '@agm/core';
import { MatDialogModule } from '@angular/material/dialog';
import { PortalModule } from '@angular/cdk/portal';
import { HttpRequestsService } from './services/http-requests.service';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ModeratorComponent } from './views/moderator/moderator.component';
import { UserPreferencesComponent } from './views/dialogComponents/userPreferences.component';
import { JwtService } from './services/jwt.service';
import { ModeratorViewDocumentComponent } from './views/moderator/moderator-view-document/moderator-view-document.component';
import { NoSanitizePipeModule } from './pipes/no-sanitizer-pipe.module';
import { AboutComponent } from './views/about/about.component';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { LearningQuestionsComponent } from './views/labs/showcases/running-lab//learning-questions/learning-questions.component';
import { ActionsComponent } from './views/labs/showcases/running-lab//actions/actions.component';
import { QuestionFormComponent } from './views/labs/showcases/running-lab//cities/city/question-form/question-form.component';
import { ActionFormComponent } from './views/labs/showcases/running-lab//cities/city/action-form/action-form.component';
import { DatePipe } from '@angular/common';
import { LqDialogComponent } from './views/labs/showcases/running-lab//cities/city/lq-dialog/lq-dialog.component';
import { ActivityDialogComponent } from './views/labs/showcases/running-lab//cities/city/activity-dialog/activity-dialog.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ScrollTopComponent } from './views/scroll-top/scroll-top.component';
import { CityEvaluationComponent } from './views/labs/showcases/running-lab//cities/city/city-evaluation/city-evaluation.component';
import { ChartsModule } from 'ng2-charts';
import { LabsComponent } from './views/labs/labs.component';
import { FusilliProjectComponent } from './views/labs/fusilli-project/fusilli-project.component';
import { CityDNAComponent } from './views/labs/lab-cities/lab-city/city-dna/city-dna.component';
import { LabCityActionsComponent } from './views/labs/lab-cities/lab-city/lab-city-actions/lab-city-actions.component';
import { FusilliImpactsComponent } from './views/labs/lab-cities/lab-city/fusilli-impacts/fusilli-impacts.component';
import { Food2030ImpactsComponent } from './views/labs/lab-cities/lab-city/food2030-impacts/food2030-impacts.component';
import { CityLearningProcessComponent } from './views/labs/showcases/running-lab/cities/city/city-learning-process/city-learning-process.component';
import { CityEvaluationActionsComponent } from './views/labs/showcases/running-lab//cities/city/city-evaluation/city-evaluation-actions/city-evaluation-actions.component';
import { CityEvaluationKpisComponent } from './views/labs/showcases/running-lab//cities/city/city-evaluation/city-evaluation-kpis/city-evaluation-kpis.component';
import { CityFormativeEvaluationComponent } from './views/labs/showcases/running-lab//cities/city/city-evaluation/city-formative-evaluation/city-formative-evaluation.component';
import { EvaluationProjectComponent } from './views/labs/showcases/evaluation/evaluation-project/evaluation-project.component';
import { EvaluationCitiesComponent } from './views/labs/showcases/evaluation/evaluation-cities/evaluation-cities.component';
import { ActionEvaluationComponent } from './views/labs/showcases/running-lab//cities/city/city-evaluation/city-evaluation-actions/action-evaluation/action-evaluation.component';
import { KpiEvaluationComponent } from './views/labs/showcases/running-lab//cities/city/city-evaluation/city-evaluation-kpis/kpi-evaluation/kpi-evaluation.component';
import { EvaluationProjectKpisComponent } from './views/labs/showcases/evaluation/evaluation-project/evaluation-project-kpis/evaluation-project-kpis.component';
import { BaselineComponent } from './views/labs/showcases/running-lab//cities/city/city-evaluation/city-formative-evaluation/baseline/baseline.component';
import { NextComponent } from './views/labs/showcases/running-lab//cities/city/city-evaluation/city-formative-evaluation/next/next.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CityEvaluationFusilliImpactsComponent } from './views/labs/showcases/running-lab//cities/city/city-evaluation/city-evaluation-fusilli-impacts/city-evaluation-fusilli-impacts.component';
import { CityEvaluationFood2030ImpactsComponent } from './views/labs/showcases/running-lab//cities/city/city-evaluation/city-evaluation-food2030-impacts/city-evaluation-food2030-impacts.component';
import { MatMenuModule } from '@angular/material/menu';
import { NavigationHistoryService } from './services/navigation-history.service';
import { TemplateComponent } from './views/labs/showcases/running-lab//cities/city/city-evaluation/template/template.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { RunningLabComponent } from './views/labs/showcases/running-lab/running-lab.component';
import { ShowdownModule } from 'ngx-showdown';
import { InfoDialogComponent } from './views/labs/showcases/running-lab/cities/city/info-dialog/info-dialog.component';
import { KpiDialogComponent } from './views/labs/showcases/running-lab/cities/city/kpi-dialog/kpi-dialog.component';
import { SafePipe } from './pipes/safe.pipe';
@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    MainDialogComponent,
    UsecaseLocationComponent,
    ModeratorComponent,
    UserPreferencesComponent,
    ModeratorViewDocumentComponent,
    AboutComponent,
    LearningQuestionsComponent,
    ActionsComponent,
    QuestionFormComponent,
    ActionFormComponent,
    LqDialogComponent,
    ActivityDialogComponent,
    ScrollTopComponent,
    CityEvaluationComponent,
    LabsComponent,
    FusilliProjectComponent,
    CityDNAComponent,
    LabCityActionsComponent,
    FusilliImpactsComponent,
    Food2030ImpactsComponent,
    CityLearningProcessComponent,
    CityEvaluationActionsComponent,
    CityEvaluationKpisComponent,
    CityFormativeEvaluationComponent,
    EvaluationProjectComponent,
    EvaluationCitiesComponent,
    ActionEvaluationComponent,
    KpiEvaluationComponent,
    EvaluationProjectKpisComponent,
    BaselineComponent,
    NextComponent,
    CityEvaluationFusilliImpactsComponent,
    CityEvaluationFood2030ImpactsComponent,
    TemplateComponent,
    RunningLabComponent,
    InfoDialogComponent,
    KpiDialogComponent,
    SafePipe,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormModule,
    HttpClientModule,
    QuillModule.forRoot(),
    KeycloakAngularModule,
    FormsModule,
    SearchModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBHOcj98yoW9qa9dZVm9Uapr3VsyWnnbOw',
    }),
    MatDialogModule,
    PortalModule,
    AngularSvgIconModule.forRoot(),
    ReactiveFormsModule,
    NoSanitizePipeModule,
    SweetAlert2Module.forRoot(),
    MatSlideToggleModule,
    ChartsModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    MatAutocompleteModule,
    ShowdownModule,
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService],
    },
    DocumentService,
    HttpRequestsService,
    GoogleMapsAPIWrapper,
    JwtService,
    DatePipe,
    NavigationHistoryService
  ],
  
  bootstrap: [AppComponent],
})
export class AppModule {}
